<script>
	import { Marquee } from '$lib/components/Global/Marquee';
	import cgd from '$lib/assets/images/partners/CGD.svg';
	import santander from '$lib/assets/images/partners/santander.svg';
	import ctt from '$lib/assets/images/partners/banco-ctt.svg';
	import bpi from '$lib/assets/images/partners/bpi.svg';
	import abanca from '$lib/assets/images/partners/abanca.svg';
	import novobanco from '$lib/assets/images/partners/novobanco.svg';
	import bankinter from '$lib/assets/images/partners/bankinter.svg';
	import eurobic from '$lib/assets/images/partners/eurobic.svg';
	import bancobni from '$lib/assets/images/partners/bancobni.svg';

	import cetelem from '$lib/assets/images/partners/cetelem.svg';
	import cofidis from '$lib/assets/images/partners/cofidis.svg';
	import uci from '$lib/assets/images/partners/UCI.svg';
	import { lazyLoad } from '$lib/actions/lazyLoad';
	import { twMerge } from 'tailwind-merge';

	const banks = [
		{ ABANCA: abanca },
		{ EuroBic: eurobic, class: 'opacity-50 h-12' },
		{ BPI: bpi },
		{ CTT: ctt },
		{ Santander: santander },
		{ bankinter: bankinter },
		{ bancobni: bancobni, class: 'h-20 opacity-70' },
		{ cetelem: cetelem },
		{ CGD: cgd },
		{ cofidis: cofidis, class: 'h-32 opacity-70' },
		{ novobanco: novobanco },
		{ UCI: uci }
	];
</script>

<div class="overflow-hidden bg-light">
	<Marquee class="h-72 gap-16 grayscale lg:h-96" speed="20s">
		{#each banks as bank, key}
			<img
				use:lazyLoad={Object.values(bank)[0]}
				loading="lazy"
				class={twMerge('h-12 w-full lg:max-h-full', bank.class)}
				alt={Object.keys(bank)[0]}
			/>
		{/each}
		{#each banks as bank, key}
			<img
				use:lazyLoad={Object.values(bank)[0]}
				loading="lazy"
				class={twMerge('h-12 w-full lg:max-h-full', bank.class)}
				alt={Object.keys(bank)[0]}
			/>
		{/each}
		{#each banks as bank, key}
			<img
				use:lazyLoad={Object.values(bank)[0]}
				loading="lazy"
				class={twMerge('h-12 w-full lg:max-h-full', bank.class)}
				alt={Object.keys(bank)[0]}
			/>
		{/each}
	</Marquee>
</div>
